/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordEventDirective } from './record-event.directive';
import { RecordEventService } from './record-event.service';
import { WindowProvider } from '../../common/services/window.service';

/**
 * A module that provides Telemetry event recording functionality.
 */
@NgModule({
  declarations: [
    RecordEventDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RecordEventDirective,
  ],
  providers: [
    RecordEventService,
    WindowProvider,
  ],
})
export class TelemetryModule { }
